import { render, staticRenderFns } from "./printertemplate.vue?vue&type=template&id=32fa1aa3&"
import script from "./printertemplate.vue?vue&type=script&lang=js&"
export * from "./printertemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports